import React from "react";
import partners from "../../data/partners.json";
import "./marquee.css";

const MarqueeSection = () => {
  const logos = partners;

  return (
    <div className="py-5 md:py-10 flex flex-col items-center">
      <div className="max-w-7xl w-full text-center">
        <h3 className="mb-2 text-2xl font-bold md:text-4xl text-[#da2128] capitalize">
          Our Partners
        </h3>

        <p className="mb-6 text-gray-600 md:text-lg">
          Trusted by industry-leading brands across the region
        </p>


        <div className="marquee-wrapper">
          <div className="marquee-track mb-4">
            {/* Multiple sets for seamless infinite scroll */}
            {[...logos, ...logos, ...logos, ...logos].map((partner, index) => (
              <a
                key={`${partner.name}-${index}`}
                href={partner.url}
                target="_blank"
                rel="nofollow"
                className="flex items-center justify-center p-3 min-w-[120px] transition hover:scale-105"
              >
                <img src={partner.icon} alt={partner.name} className="h-8 object-contain" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarqueeSection;
